import { Box, Container } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import HoverMeasurementsReportSales from '../../assets/images/hover_measurements_report_sales.gif';
import { ContentCard, IntersectBox } from '../common';
import SectionWrapper from './SectionWrapper';

const MarketingAndSales: React.FC = () => {
  const [isIntersected, setIsIntersected] = useState<boolean>(false);

  const onInterSect = (entry: number) => {
    if (entry) {
      setIsIntersected(true);
    }
  };
  return (
    <IntersectBox
      justifyContent="center"
      w="100%"
      setSectionIntersect={onInterSect}
    >
      <Container maxW="1200px" px={500} mb={{ base: '72px', desktop: '152px' }}>
        <SectionWrapper mb={{ base: '72px', desktop: '150px' }}>
          <ContentCard
            maxW="xl"
            title="MARKETING"
            header="Help homeowners see the possibilities"
            topBody="Our collaborative 3D model not only helps homeowners visualize their project,
            it gets you all on the same page before the work starts. And fast, accurate measurements
            and estimates make for a simpler, more transparent process. All of which means even
            the most challenging projects feel possible."
          />
          <StaticImage
            width={380}
            style={{ margin: '0 auto' }}
            placeholder="blurred"
            alt="marketing"
            src="../../assets/images/exterior_contractors_marketing.png"
            objectFit="contain"
          />
        </SectionWrapper>
        <SectionWrapper mt={{ base: '72px', desktop: '150px' }}>
          <Box w="481px" h="362px" px={0} d={{ base: 'none', desktop: 'flex' }}>
            {isIntersected && (
              <img
                src={HoverMeasurementsReportSales}
                alt="hover measurements sales"
                width={481}
                height={362}
              />
            )}
          </Box>
          <ContentCard
            maxW="xl"
            title="SALES"
            header="Work smarter, Not harder"
            topBody="Best-in-industry measurements, collaborative tools, and fast and accurate
            estimates make it easier to build your business while building better relationships
            with your customers."
          />
          <Box mx="auto" d={{ base: 'flex', desktop: 'none' }}>
            {isIntersected ? (
              <img
                src={HoverMeasurementsReportSales}
                alt="hover measurements sales"
                width={576}
                height={433}
              />
            ) : (
              <Box minH={{ base: '300px', tablet: '400px' }} />
            )}
          </Box>
        </SectionWrapper>
      </Container>
    </IntersectBox>
  );
};

export default MarketingAndSales;
